import React from "react";
import NoSidebarLayout from "../../components/Layout/NoSidebarLayout";
import { Alert, Space } from "antd";
import Title from "antd/lib/typography/Title";

const LoginPage: React.FC = () => {
  return (
    <div>
      <NoSidebarLayout>
        <div className="flex h-full items-center w-full m-auto">
          <Space direction="vertical">
            <Title className="text-center" level={3}>
              iLivestock
            </Title>
            <Alert
              message={
                <span data-testid="legacy-notice">
                  This portal has been discontinued, please contact our <a href="mailto:support@ilivestock.co.uk">support team</a> for any assistance.
                </span>
              }
              showIcon
              type="warning"
            />
          </Space>
        </div>
      </NoSidebarLayout>
    </div>
  );
};

export default LoginPage;
